import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import CompanyCamIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/CompanyCamIcon';

import CompanycamButton from '../OtherComponents/CompanycamButton';

const CompanycamStrategy = {
  previewInfo: {
    name: 'CompanyCam',
    iconSvg: <CompanyCamIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'CompanyCam',
    category: 'Document your jobs and automatically save photos to projects',
    details: (
      <>
        <Typography paragraph>
          CompanyCam is a photo-based solution created for contractors, by contractors. Users can take unlimited photos
          which are location and time stamped, sent to the cloud, and stored securely. Every photo is organized by
          project and instantly available to your team, allowing you to see what’s going on anytime, anywhere.
        </Typography>
        <h4>Why CompanyCam?</h4>
        <Typography paragraph>
          Founded in 2015, CompanyCam has changed how contractors work. Through its visual-first communication and
          accountability tools, contractors can stay up to date on every job, project, and team from anywhere. With over
          10M projects and 240M photos, contractors everywhere are simplifying their documentation and communication
          processes with CompanyCam.{' '}
          <a href="https://companycam.com/housecallpro" target="_blank" rel="noreferrer">
            Learn more
          </a>
        </Typography>
        <h4>What you get with CompanyCam:</h4>
        <Typography paragraph>
          Photos can be annotated with drawings, arrows, comments, tags, and voice notes.
        </Typography>
        <Typography paragraph>
          Users can create project timelines, photo galleries, reports, and before and after photos through the app.
        </Typography>
        <Typography>
          Sharing photos with customers has never been easier, and keeping your entire process organized has never been
          simpler.
        </Typography>
      </>
    ),
    iconSvg: <CompanyCamIcon size="xlarge" color="primary" />,
  },
  media: {
    youtubeId: 'wBFvvb_ajk8',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    hideToggle: true,
    appActionButton: <CompanycamButton />,
    description: (
      <div>
        <Grid container spacing={8}>
          <Grid item>
            <Typography align="left">
              <a href="https://companycam.com/pricing" target="_blank" rel="noreferrer">
                https://companycam.com/pricing
              </a>
            </Typography>
          </Grid>
          <Grid item>
            <Typography align="center" color="textSecondary">
              To use the integration, you must have an account with CompanyCam. Plans from $0 - $29/month
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
  },
  supportContacts: [{ type: 'Support', contact: <a href="mailto:sales@companycam.com">sales@companycam.com</a> }],
};

export default CompanycamStrategy;
